import React, { Component } from 'react';
import {
  ActivityIndicator,
  Alert,
  Dimensions,
  Image,
  InteractionManager,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import _ from 'lodash';

import { Keyboard, KeyboardAwareScrollView } from '../modules';
import LoadingIndicator from '../common/LoadingIndicator';
import APIClient from '../utils/APIClient';

const contentWidth = Math.min(Dimensions.get('window').width - 40, 300);

class PaymentScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {params} = navigation.state;
    return {
      headerBackTitle: null,
      headerTitle: 'Thông tin thanh toán',
    };
  };

  constructor (props) {
    super(props);

    this.state = {
      status: 'none',
      bank: '',
      city: '',
      branch: '',
      accountNumber: '',
      accountHolder: '',
    };
  }

  componentDidMount () {
    if (Platform.OS === 'web') {
      this._loadData();
    } else {
      InteractionManager.runAfterInteractions(() => {
        this._loadData();
      });
    }
  }

  componentWillUnmount () {
  }

  _updateInputValue (name, value) {
    this.setState({
      [name]: value,
    });
  }

  _focusTextInput (name) {
    const textInput = this.refs[name];
    if (textInput) {
      textInput.focus();
    }
  }

  _loadData = async () => {
    this.setState({
      status: 'loading',
    });

    const {response, error} = await APIClient.GET('/payment');
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    if (response && response.response) {
      const data = response.response;
      const {bank, city, branch, accountNumber, accountHolder} = data;
      this.setState({
        data,
        bank,
        city,
        branch,
        accountNumber,
        accountHolder,
      });
    } else {
      const message = error && error.message
        ? error.message
        : 'Có lỗi xảy ra, vui lòng thử lại sau';
      if (Platform.OS === 'web') {
        alert(message);
      } else {
        Alert.alert(
          global.__APP_NAME__,
          message,
        );
      }
    }
    this.setState({
      status: 'done',
    });
  }

  _submit = async () => {
    if (Platform.OS !== 'web') {
      Keyboard.dismiss();
    }

    const {bank, city, branch, accountNumber, accountHolder} = this.state;
    let errorMessage, textInputRef;
    if (_.isEmpty(bank)) {
      errorMessage = 'Vui lòng nhập tên ngân hàng';
      textInputRef = 'bankTextInput';
    } else if (_.isEmpty(city)) {
      errorMessage = 'Vui lòng nhập tên thành phố';
      textInputRef = 'cityTextInput';
    } else if (_.isEmpty(branch)) {
      errorMessage = 'Vui lòng nhập tên chi nhánh';
      textInputRef = 'branchTextInput';
    } else if (_.isEmpty(accountNumber)) {
      errorMessage = 'Vui lòng nhập số tài khoản';
      textInputRef = 'accountNumberTextInput';
    } else if (_.isEmpty(accountHolder)) {
      errorMessage = 'Vui lòng nhập tên chủ tài khoản';
      textInputRef = 'accountHolderTextInput';
    }
    if (errorMessage) {
      if (Platform.OS === 'web') {
        alert(errorMessage);
        this._focusTextInput(textInputRef);
      } else {
        Alert.alert(
          global.__APP_NAME__,
          errorMessage,
          [
            {text: 'OK', onPress: () => this._focusTextInput(textInputRef)},
          ],
        );
      }
      return;
    }

    this.setState({
      status: 'editing',
    });

    const data = {
      bank,
      city,
      branch,
      account_number: accountNumber,
      account_holder: accountHolder,
    };
    const {response, error} = await APIClient.POST('/payment', data);
    this._handleUpdateNetworkResponse(response, error);
  };

  _handleUpdateNetworkResponse = (response, error) => {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    let message;
    if (response && response.response && response.response.status === true) {
      message = response.response.message;
    } else {
      message = error && error.message
        ? error.message
        : 'Có lỗi xảy ra, vui lòng thử lại sau';
    }

    if (Platform.OS === 'web') {
      alert(message);
    } else {
      Alert.alert(
        global.__APP_NAME__,
        message,
      );
    }

    this.setState({
      status: 'done',
    });
  };

  render () {
    const {status, data, bank, city, branch, accountNumber, accountHolder} = this.state;
    return (
      <View
        style={styles.container}>
        {!_.isNil(data) && <KeyboardAwareScrollView
          automaticallyAdjustContentInsets={false}
          keyboardDismissMode={Platform.OS === 'ios' ? 'on-drag' : 'none'}
          keyboardShouldPersistTaps='always'
          containerContentStyle={styles.contentContainer}
          style={styles.content}>

          <Text
            style={[
              styles.inputTitleText, {
                marginTop: 24,
              }]}>
            Tên ngân hàng
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='bankTextInput'
              value={bank}
              placeholder='Tên ngân hàng'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              autoCapitalize='words'
              returnKeyType='next'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('bank', text)}
              onSubmitEditing={() => this._focusTextInput('cityTextInput')}/>
          </View>

          <Text
            style={styles.inputTitleText}>
            Thành phố
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='cityTextInput'
              value={city}
              placeholder='Thành phố'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              autoCapitalize='words'
              returnKeyType='next'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('city', text)}
              onSubmitEditing={() => this._focusTextInput('branchTextInput')}/>
          </View>

          <Text
            style={styles.inputTitleText}>
            Chi nhánh ngân hàng
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='branchTextInput'
              value={branch}
              placeholder='Chi nhánh ngân hàng'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              autoCapitalize='words'
              clearButtonMode='while-editing'
              returnKeyType='next'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('branch', text)}
              onSubmitEditing={() => this._focusTextInput(
                'accountNumberTextInput')}/>
          </View>

          <Text
            style={styles.inputTitleText}>
            Số tài khoản
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='accountNumberTextInput'
              value={accountNumber}
              placeholder='Số tài khoản'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              returnKeyType='next'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('accountNumber',
                text)}
              onSubmitEditing={() => this._focusTextInput(
                'accountHolderTextInput')}/>
          </View>

          <Text
            style={styles.inputTitleText}>
            Chủ tài khoản
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='accountHolderTextInput'
              value={accountHolder}
              placeholder='Chủ tài khoản'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              autoCapitalize='words'
              returnKeyType='go'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('accountHolder',
                text)}
              onSubmitEditing={this._submit}/>
          </View>

          <TouchableOpacity
            activeOpacity={0.75}
            onPress={this._submit}
            style={[
              styles.actionButton, {
                marginTop: 20,
                marginBottom: 20,
                alignSelf: 'center',
              }]}>
            <Image
              source={require('../img/btn.png')}
              style={styles.actionButtonImage}/>
            <Text
              style={styles.actionButtonText}>
              Cập nhật thông tin
            </Text>
            {status === 'editing' && <View
              style={styles.actionActivity}>
              <ActivityIndicator
                animating={true}
                color='#ffffff'
                style={styles.actionActivityIndicator}/>
            </View>}
          </TouchableOpacity>
        </KeyboardAwareScrollView>}

        {status === 'loading' && <LoadingIndicator/>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
  },
  contentContainer: {},

  inputTitleText: {
    width: contentWidth,
    marginTop: 16,
    alignSelf: 'center',
    color: '#000000',
    fontSize: 16,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  input: {
    width: contentWidth,
    height: 44,
    marginTop: 5,
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#e2d7ba',
    backgroundColor: '#ffffff',
  },
  textInput: {
    marginLeft: 12,
    padding: 0,
    color: '#51585e',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
    backgroundColor: 'transparent',
    ...Platform.select({
      web: {
        outline: 'transparent',
      },
    }),
  },

  actionButton: {
    width: contentWidth,
    height: 56,
    marginTop: 10,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  actionButtonImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: contentWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  actionButtonText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  actionActivity: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  actionActivityIndicator: {},
});

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default PaymentScreen;



// WEBPACK FOOTER //
// ./src/payment/PaymentScreen.js